export default __webpack_public_path__ + "assets/images/icon-send.4ef36299b156ea479a4316841cc93350.svg";